<template>
    <v-container>
        <v-row>
            <v-col>
                <h4 class="text-h4">Stock Issued by dimension Report</h4>
            </v-col>
        </v-row>
        <v-row class="mt-1">
            <v-col>
                <v-form>
                    <v-row>
                        <v-col>
                            <DatePicker
                                label="From"
                                outlined
                                v-model="form.date_from"
                                dense
                                hide-details/>
                        </v-col>
                        <v-col>
                            <DatePicker
                                label="To"
                                outlined
                                v-model="form.date_to"
                                dense
                                hide-details/>
                        </v-col>
                        <v-col>
                            <v-btn class="primary" block :loading="loading" @click="handleStockIssuedByDimension">
                                <v-icon left>mdi-magnify</v-icon>
                                search
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-form>
            </v-col>
        </v-row>
        <v-row >
            <v-col>
                <v-text-field
                    label="Dimension Group"
                    v-model="filter.dimension_group"
                    prepend-inner-icon="mdi-filter"
                    shaped
                    filled
                    dense
                    single-line
                    hide-details>
                </v-text-field>
            </v-col>
             <v-col>
                <v-text-field
                    label="Dimension"
                    v-model="filter.dimension"
                    prepend-inner-icon="mdi-filter"
                    shaped
                    filled
                    dense
                    single-line
                    hide-details>
                </v-text-field>
            </v-col>
             <v-col>
                <v-text-field
                    label="Item"
                    v-model="filter.item"
                    prepend-inner-icon="mdi-filter"
                    shaped
                    filled
                    dense
                    single-line
                    hide-details>
                </v-text-field>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-simple-table dense>
                    <thead>
                        <tr>
                            <th>Dimension Group</th>
                            <th>Dimension</th>
                            <th>Item</th>
                            <th>Quantity</th>
                            <th>Measure Unit</th>
                            <th>Amount</th>
                            <th>Voucher</th>
                            <th>Issued At</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(v, i) in filterList" :key="i">
                            <td>{{v.dimension_group}}</td>
                            <td>{{v.dimension}}</td>
                            <td>{{v.item}}</td>
                            <td>{{formatNumber(v.quantity, 2)}}</td>
                            <td>{{v.abbreviation}}</td>
                            <td>{{formatNumber(v.amount, 2)}}</td>
                            <td>{{v.code}}</td>
                            <td>{{v.date}}</td>
                        </tr>
                        <tr>
                            <td colspan="5"></td>
                            <td>Total</td>
                            <td>{{formatNumber(getTotal(filterList, 'amount'), 2)}}</td>
                        </tr>
                    </tbody>
                </v-simple-table>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { formatNumber } from 'accounting';
import DatePicker from '../../components/common/DatePicker.vue'
import {getStockIssuedByDimension} from './../../services/stockJournal/dimension';
import {getTotal } from "./../../utils/accounting";

import moment from 'moment';

export default {
    components: {
        DatePicker
    },
    data() {
        return {
            list: [],
            loading: false,
            form: {
                date_from: moment().startOf('month').format('YYYY-MM-DD'),
                date_to: moment().format('YYYY-MM-DD')
            },
            filter: {
                dimension_group: "",
                dimension: "",
                item: ""
            },
            warehouseId: null
        }
    },
    computed: {
        filterList() {
            return this.list.filter( each => {
                return each.dimension_group.toLowerCase().indexOf(this.filter.dimension_group.toLowerCase()) > -1
                            && each.dimension.toLowerCase().indexOf(this.filter.dimension.toLowerCase()) > -1
                            && each.item.toLowerCase().indexOf(this.filter.item.toLowerCase()) > -1;
            })
        }
    },
    methods: {
        formatNumber,
        getTotal,
        async handleStockIssuedByDimension() {
            this.loading = true;
            this.list = [];
            let params = {
                date_from: this.form.date_from,
                date_to: this.form.date_to
            };
            let res = await getStockIssuedByDimension({...params, warehouse_id: this.warehouseId});
            this.list = res.data;
            this.loading = false;
        },
    },
    created() {
        this.warehouseId = this.$route.params.warehouseId;
    },
    mounted() {
        this.handleStockIssuedByDimension();
    }
}
</script>

<style>

</style>